import { EnumSituacaoPedido } from "../model/enums/enum-situacao-pedido";

export function alterarCorSituacaoPedido(numero: number) {
    switch (numero) {
        case EnumSituacaoPedido.INVALIDO:
            return "#9E9E9E"
        case EnumSituacaoPedido.AGUARDANDO_CONFIRMACAO:
            return "#F4B400"
        case EnumSituacaoPedido.CONFIRMADO:
            return "#0F9D58"
        case EnumSituacaoPedido.EM_PREPARO:
            return "#4285F4"
        case EnumSituacaoPedido.ENVIADO:
            return "#3367D6"
        case EnumSituacaoPedido.ENTREGUE:
            return "#34A853"
        case EnumSituacaoPedido.CANCELADO:
            return "#DB4437"
    }
}